export type PfmModeIndex = 'bluetoothpairingguide' | 'contactsupport' | 'normal' | 'support' | 'compare';
export enum PfmMode {
  BluetoothPairingGuide = 'bluetoothpairingguide',
  ContactSupport = 'contactsupport',
  Normal = 'normal',
  Support = 'support',
  Compare = 'compare',
}
